import React from 'react';
import { Helmet } from 'react-helmet';
import { SITE } from '../../data/site';

/** Per-route <head> tags. Defaults to the site-wide title/description. */
const Seo = ({ title, description = SITE.description, path = '/' }) => {
  const fullTitle = title ? `${title} | BOOP` : SITE.title;
  const url = `${SITE.url}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default Seo;
